import React from "react";
import img from "../cloudassets/consultingimage.png";
import './CloudConsulting.css';

export default function CloudConsulting() {
  return (
    <div id="cloud-consulting" className="cloudmainclass">
      <div className="left">
        <h2>Cloud Consulting That Builds a Scalable Roadmap</h2>
        <p>
          Enterprises need more than cloud adoption—scalability is key.
          BastionEx’s cloud consulting services across AWS, Azure, and GCP
          modernize systems, accelerate secure migrations, and build resilient
          cloud-native architectures. Through comprehensive assessments,
          optimized strategies, and continuous support, we enable faster
          innovation, stronger security and compliance, and measurable
          ROI—backed by proven multi-cloud expertise.
        </p>
      </div>
      <div className="right">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
